import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import {
  Sun,
  Moon,
} from "lucide-react";
import "../../App.css";
function Header() {
  const navigate = useNavigate();

  const [theme, setTheme] = useState("dark");

useEffect(() => {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const defaultTheme = isMobile ? "light" : "dark";

  const savedTheme = localStorage.getItem("theme");
  const selectedTheme = savedTheme || defaultTheme;

  setTheme(selectedTheme);

  if (selectedTheme === "light") {
    document.documentElement.setAttribute("data-theme", "light");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }

  // Save the default theme if the user has not selected one before
  if (!savedTheme) {
    localStorage.setItem("theme", defaultTheme);
  }
}, []);
  const toggleTheme = () => {
    console.log("button clicked");
    if (theme === "dark") {
      console.log("Switching to light theme");
      setTheme("light");
      document.documentElement.setAttribute("data-theme", "light");
      localStorage.setItem("theme", "light");
    } else {
      console.log("Switching to dark theme");
      setTheme("dark");
      document.documentElement.removeAttribute("data-theme");
      localStorage.setItem("theme", "dark");
    }
  };

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="page-title">
          OKR PORTAL
        </div>

        <div className="breadcrumb">
         
          <span>›</span>
          <span>
             {window.location.pathname
        .split("/")
        .filter(Boolean)[0]
        ?.replace(/-/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase()).replace("Okr","OKR") }
          </span>
        </div>
      </div>

      <div className="topbar-right">
      
        <button
          className="topbar-btn"
          onClick={toggleTheme}
          title="Toggle Theme"
        >
{theme === "dark" ? (
    <Sun size={19} strokeWidth={2} />
  ) : (
    <Moon size={19} strokeWidth={2} />
  )}
        </button>

      
              </div>
    </header>
  );
}

export default Header;